import { CSVParser } from '@sourceflow-uk/cms-csv-parser';

const ALLOWED_TYPES = ['text', 'formatted_text', 'number', 'date', 'datetime', 'form', 'code', 'checkbox', 'dropdown', 'category'];

function CSVImporter({ ...props }) {
  const filteredSchema = props.category.schema.filter((field) => ALLOWED_TYPES.includes(field.data_type));
  const category = { ...props.category, schema: filteredSchema };

  return <CSVParser {...props} category={category} />;
}

export default CSVImporter;
